function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  className: "grid_svg__Thumbnail_Pro grid_svg__Gallery grid_svg__Layout_Grid"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#80B1FF",
  d: "M33 34H15c-.55 0-1-.45-1-1V15c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1zm25-1V15c0-.55-.45-1-1-1H39c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1zM34 57V39c0-.55-.45-1-1-1H15c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1zm24 0V39c0-.55-.45-1-1-1H39c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1z",
  className: "grid_svg__illus-clr-1"
}));

function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='72' height='72' fill='none' viewBox='0 0 72 72'%3E %3Cg class='Thumbnail_Pro Gallery Layout_Grid'%3E %3Cpath fill='%2380B1FF' d='M33 34H15c-.55 0-1-.45-1-1V15c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1Zm25-1V15c0-.55-.45-1-1-1H39c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1ZM34 57V39c0-.55-.45-1-1-1H15c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1Zm24 0V39c0-.55-.45-1-1-1H39c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h18c.55 0 1-.45 1-1Z' class='illus-clr-1'/%3E %3C/g%3E %3C/svg%3E";
export { SvgGrid as ReactComponent };